import {useContext, useRef, useState} from 'react'

import PropTypes from 'prop-types'

import {toQueryString} from '@s-ui/js/lib/string'
import AtomImage from '@s-ui/react-atom-image'
import Context from '@s-ui/react-context'
import {useRouter} from '@s-ui/react-router'
import FormInstantOffer, {formInstantOfferStepKeys} from '@adv-mt/mt-form-instant-offer'
import ListBasic from '@adv-mt/mt-list-basic'
import TitleBasic, {titleBasicColors, titleBasicSizes, titleBasicTags} from '@adv-mt/mt-title-basic'

import {useLandingInstantOfferAnalyticsTrack} from '../../hooks/useLandingInstantOfferAnalyticsTrack.js'
import {useInstantOfferAppraisalInfo} from './useInstantOfferAppraisalInfo.js'

const BASE_CLASS_NAME = 'mt-LandingInstantOffer'

const LandingFormInstantOffer = ({currentUser = {}, sellVehicleConfigForm}) => {
  const {domain, i18n} = useContext(Context)
  const {push} = useRouter()
  const [currentStep, setCurrentStep] = useState(formInstantOfferStepKeys.VEHICLE_DATA_STEP)
  const scrollRef = useRef()

  const {
    trackFormFieldSelected,
    trackFormFieldValueAutocompleted,
    trackInstantOfferNoAvailable,
    trackInstantOfferRequestConfirmed,
    trackFormFieldsError,
    trackNextConfirmed
  } = useLandingInstantOfferAnalyticsTrack()

  const {listBasicProps} = useInstantOfferAppraisalInfo({
    currentStep
  })

  const config = domain.get('config')
  const {INSTANT_OFFER_SELL_TO_DEALER_PATTERN} = config.get('page')
  const {C2B_ORIGINS} = config.get('c2b')
  const URL_STATICS_IMAGES = config.get('URL_STATICS_IMAGES')
  const titleImageUrl = `${URL_STATICS_IMAGES}coches/pta/lightning-fast.svg`

  const handleGetInstantOfferSuccess = ({instantOfferId}) => {
    trackInstantOfferRequestConfirmed()
    push(`${INSTANT_OFFER_SELL_TO_DEALER_PATTERN}/?ioId=${instantOfferId}&origin=instantOfferLanding`)
  }

  const handleGetInstantOfferNoAvailable = fields => {
    trackInstantOfferNoAvailable()

    const {
      bodyTypeDoors,
      fuelId,
      km,
      makeId,
      makeName,
      modelId,
      modelName,
      plate,
      transmissionTypeId,
      versionId,
      versionName,
      year
    } = fields

    const queryParams = toQueryString({
      origin: C2B_ORIGINS.STANDALONE_EMPTY_CASE,
      bodyTypeDoors,
      fuelId,
      km,
      makeId,
      makeName,
      modelId,
      modelName,
      plate,
      transmissionTypeId,
      versionId,
      versionName,
      year
    })
    push(`/vende-a-concesionario/?${queryParams}`)
  }

  const handleOnSubmitVehicleData = ({vehicleData}) => {
    trackNextConfirmed({vehicleData})
  }

  const handleOnStepChange = ({stepKey}) => {
    scrollRef.current.scrollIntoView({
      behavior: 'smooth'
    })

    setCurrentStep(stepKey)
  }

  return (
    <div className={`${BASE_CLASS_NAME}-wrapperContainer`} ref={scrollRef}>
      <div className={`${BASE_CLASS_NAME}-wrapper`} ref={scrollRef}>
        <div className={`${BASE_CLASS_NAME}-form`}>
          <div className={`${BASE_CLASS_NAME}-title`}>
            <div className={`${BASE_CLASS_NAME}-titleImage`}>
              <AtomImage src={titleImageUrl} />
            </div>
            <TitleBasic
              as={titleBasicTags.h2}
              color={titleBasicColors.black}
              size={titleBasicSizes.s}
              title={i18n.t('INSTANT_OFFER.LANDING.APPRAISE_YOUR_CAR')}
            />
          </div>
          <p className={`${BASE_CLASS_NAME}-titleDescription`}>
            {i18n.t('INSTANT_OFFER.LANDING.APPRAISE_YOUR_CAR_DESCRIPTION')}
          </p>
          <FormInstantOffer
            currentUser={currentUser}
            onStepChange={handleOnStepChange}
            onFormFieldsError={trackFormFieldsError}
            onFormFieldValueAutocompleted={trackFormFieldValueAutocompleted}
            onFormFieldValueChange={trackFormFieldSelected}
            onGetInstantOffer={handleGetInstantOfferSuccess}
            onNoOfferAvailable={handleGetInstantOfferNoAvailable}
            onSubmitVehicleData={handleOnSubmitVehicleData}
            sellVehicleConfigForm={sellVehicleConfigForm}
          />
        </div>
        <div className={`${BASE_CLASS_NAME}-info`}>
          <ListBasic {...listBasicProps} />
        </div>
      </div>
    </div>
  )
}

LandingFormInstantOffer.displayName = 'LandingFormInstantOffer'

LandingFormInstantOffer.propTypes = {
  currentUser: PropTypes.shape({
    email: PropTypes.string,
    name: PropTypes.string,
    phone: PropTypes.string
  }),
  sellVehicleConfigForm: PropTypes.object
}

export default LandingFormInstantOffer
